import { LanguageEnum } from 'constants/languages';
import { UserRoles } from 'constants/userRoles';
import { IUser } from 'interfaces/IUser';

export const isUserAdmin = (user?: IUser) =>
  user ? user.roles?.includes(UserRoles.admin) : false;

export const isUserUsingEnglishLanguage = (user: IUser) =>
  user.language?.toLowerCase() === LanguageEnum.EN.toLowerCase();
